import gql from 'graphql-tag'

export const SKYSCRAPERS = gql`
  {
    skyscraper {
      getTotal
      list {
        id
        url
        title
      }
    }
  }
`
